const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
require('magnific-popup');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  submenuOffset();
  containerFix();

  // Add attributes to iFrame to stop 'tabbing into them'. This is needed as the iFrame is added via WP content
  iframes = document.querySelectorAll('iframe');
  for (iframe of iframes) {
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
  }//for

  // Blog category sync
  $('.blogSearchTermButton').on('click', function(e){
    e.preventDefault();
    var term = $(this);
    var value = term.val();

    $('#blogTerms-select').val(value).trigger('change');
  });

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  //Search mobile
  let mobileSearchToggle = document.querySelector('#searchform-mobile .searchtoggle');
  if (mobileSearchToggle) {
    mobileSearchToggle.addEventListener('click', (ev) => {
      ev.preventDefault();
      
      //If the search input isnt showing, show it, else, carry on with submission
      if (! document.getElementById('mobileSearch').classList.contains('show')) {
        document.getElementById('mobileSearch').classList.add('show');
      } else {
        document.getElementById('searchform-mobile').submit();
      }//if

      // if ('' == document.getElementById('mobileSearch').value) {
      //   preventDefault();
      // }//if

    });
  }//if

  //If the escape key is clicked, make sure megamenu gets hidden
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      console.log('keypressinside');
      const submenus = document.querySelectorAll('.submenu');
      for (submenu of submenus) {
        submenu.style.opacity = '0';
        submenu.style.pointerEvents = 'none';
        submenu.style.visibility = 'hidden';
      }//for
    }
  });

  //If a nav item is hovered, reset the submenus values so the megamenu can show once closed with escape key (code above)
  const navItems = document.querySelectorAll('.nav-item');

  navItems.forEach(item => {
    const submenu = item.querySelector('.submenu');

    //Show megamenu
    item.addEventListener('mouseenter', function() {
      if (submenu) {
        submenu.style.opacity = 'unset';
        submenu.style.pointerEvents = 'unset';
        submenu.style.visibility = 'unset';
        
        //Set aria-hidden = false on submenu
        console.log('mouseenter');
        submenu.setAttribute('aria-hidden', false);

        //Go through all submenuItems and set the tabindex based on data-tabindex
        const tabIndexItems = submenu.querySelectorAll('.tabindexItem');
        for (tabIndexItem of tabIndexItems) {
          tabIndexItem.setAttribute('tabindex', tabIndexItem.getAttribute('data-tabindex'));
        }//for

      }
    });

    //Hide megamenu
    item.addEventListener('mouseleave', function() {
      if (submenu) {
        submenu.style.opacity = '0';
        submenu.style.pointerEvents = 'none';
        submenu.style.visibility = 'hidden';

        //Set aria-hidden = true on submenu
        console.log('mouseleave');
        submenu.setAttribute('aria-hidden', true);

        //Go through all submenuItems and remove the tabindex
        const tabIndexItems = submenu.querySelectorAll('.tabindexItem');
        for (tabIndexItem of tabIndexItems) {
          tabIndexItem.setAttribute('tabindex', '-1');
        }//for
      }
    });
  });

  // Magnific popup
  if ($('.magnific-gallery').length > 0) {

    let galleryHeroImage = document.getElementById('galleryHeroImage');
    if (galleryHeroImage) {
      galleryHeroImage.addEventListener('click', (ev) => {
        $('.firstGalleryItem').trigger('click');
      });
    }//if

    $('.magnific-gallery').magnificPopup({
      delegate: 'div .gallery-item',
      type: 'image',
      gallery: {
        enabled: true,
      },
    });

  }//if

  if ($('.magnific-gallery-mobile').length > 0) {

    $('.magnific-gallery-mobile').magnificPopup({
      delegate: 'div .gallery-item',
      type: 'image',
      gallery: {
        enabled: true,
      },
    });
  
  }//if

  //filter show/hide toggle 
  $('.filter-toggle').on('click', function() {
    var target = $(this).data("id");
    $(this).toggleClass("active");
    $("#" + target).slideToggle();
  });
  
  $('.room-submit').on('click', function() {
    refreshRoomTopSearchBar();
    $('.accomm_search').submit();
  });
  
  $('.room-perpage').on('change', function() {
    $(".room-perpage-hidden").val($(this).val());
    refreshRoomTopSearchBar();
    $('.accomm_search').submit();
  });
  
  $('#sort-ref').on('change', function() {
    //grab option an split by '-'
    //first param is the meta field to sort by
    //second param is the asc/desc value
    var value_order = $(this).val().split('-');
    $(".sort_by").val(value_order[0]); //meta field
    $(".sort_by_order").val(value_order[1]); //asc-desc
    $('.accomm_search').submit();
    
  });
  
  $('.accomm-mobile-apply').on('click', function() {
    refreshRoomTopSearchBar();
    $('.accomm_search_mobile').submit();
  });
  
  function refreshRoomTopSearchBar() {
    $("#date_from_f").val($("input[name='date_from']").val());
    $("#date_to_f").val($("input[name='date_to']").val());
    $("#per_page").val($("#perpage-ref").val());
    $("#people").val($(".people-input").val());
    $("#date_from_f_m").val($("input[name='date_from']").val());
    $("#date_to_f_m").val($("input[name='date_to']").val());
    $("#per_page_m").val($("#perpage-ref").val());
    $("#people_m").val($(".people-input").val());
    
    //check for sort options
    if($(".sort_by").length)
    {
      var value_order = $('#sort-ref').val().split('-');
      $(".sort_by").val(value_order[0]); //meta field
      $(".sort_by_order").val(value_order[1]); //asc-desc
      $('.accomm_search').submit();
    }

  }
  //room filter form submit 
  $('.accomm_search input').on('change', function() {
    refreshRoomTopSearchBar();
    
    //deselects parent locations when children are selected
    var dataDeselect = $(this).data('deselect');
    if(dataDeselect)
    {    
      if ($(this).is(':checked')) {    
        if (dataDeselect) {
            var checkboxesToDeselect = dataDeselect.split(',');
            console.log(checkboxesToDeselect);
            checkboxesToDeselect.forEach(function(checkboxId) {
              console.log(checkboxId);
                $('#loc_' + checkboxId).prop('checked', false);
            });
        }
      }
    }
    
    $('.accomm_search').submit();
  });

  //If checkbox-filter label is clicked, trigger click on input inside (mainly for accessibility tabbing)
  $('.checkbox-filter > label').on('keyup', function(ev) {
    if (ev.keyCode === 13) {
      console.log('inside');
      const input = $(this).find('input');
      input.trigger('click');
    }
  });
  
  //Get all filtering checkboxes and if input is checked, get the tick to show
  let filteringCheckboxes = document.querySelectorAll('.checkbox-filter input:checked');
  for (filteringCheckbox of filteringCheckboxes) {
    label = filteringCheckbox.parentElement;
    label.classList.add('show');
  }//for
  
  //filtering labels::after opacity
  $('.checkbox-filter input').on('change', function() {
    
    labelParent = $(this).parent();
    label = labelParent[0];
    
    if ($(this).is(':checked')) {      
      label.classList.add('show');
    } else {
      label.classList.remove('show');
    }//if
  
  });

  // Venue accessibility
  let accessibilityButtons = document.querySelectorAll('.venue-accessibility-button');
  for (accessibilityButton of accessibilityButtons) {

    accessibilityButton.addEventListener('click', (ev) => {
      ev.target.classList.toggle('rotate');
      document.getElementById(ev.target.getAttribute('data-attribute-target')).classList.toggle('show');
    });

  }//for

  // Filter toggles
  let filterToggles = document.querySelectorAll('.filter-toggle');
  for (filterToggle of filterToggles) {

    filterToggle.addEventListener('click', (ev) => {
      document.getElementById(ev.target.getAttribute('data-id')).classList.toggle('mshow');
    });

  }//for

  // Skip
  $('#skip').on('click', function() {
    console.log('click');
    if ($('body').hasClass('home')) {
      var headerHeight = 0;
    } else {
      var headerHeight = $('#header').outerHeight();
    }//if
    var secondSection = $('section:eq(1)'); 
    $('html, body').animate({
      scrollTop: secondSection.offset().top - headerHeight
    }, 1000);
    secondSection.trigger('focus');
  });

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  // $("header .nav [href]").each(function () {
  //   if (this.href == window.location.href) {
  //     $(this).addClass("active");
  //   }
  // });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  // Catering filters
  $('.requirement').on('click', function() {
    var requirement = $(this);
    $('.requirement').removeClass('active');
    requirement.addClass('active');
    var dataRefValue = requirement.data('ref');
    
    if (dataRefValue == 'all') {
      $('.menu-row').each(function() {
        var menu = $(this);
        menu.show();
      });
    } else {
      $('.menu-row').each(function() {
        var menu = $(this);
        var reqSpan = menu.find('.req[data-req="' + dataRefValue + '"]');
        console.log(reqSpan);
        if (reqSpan.length == 0) {
          menu.hide();
        } else {
          menu.show();
        }
      });
    }
  });

  //If the search form is empty, don't search the form
  let searchForm = document.getElementById('searchform');

  //Set input to empty value, so when the search is clicked after a submission, it will show the input again
  document.getElementById('search').value = '';

  searchForm.addEventListener('submit', (ev) => {
    
    if ('' == document.getElementById('search').value) {

      ev.preventDefault();

      if (! searchForm.classList.contains('active')) {
        searchForm.classList.add('active');
      }//if
      
      document.getElementById('search').focus();

    }//if

  });

  // Search toggle
  $('.searchradios label').on('click', function() {
    var associatedInput = $(this).prev('input');
    var dataActionValue = associatedInput.data('action');
    $('#searchform').attr('action', dataActionValue);
    
    //change input name
    $("#search").attr('name', associatedInput.data('param'));

    $('#searchform').addClass('active');
  });

  //if .searchInput::after is clicked, remove text from .searchInput
  document.getElementById('searchInputEmpty').addEventListener('click', (ev) => {
    document.getElementById('search').value = '';
  });

  // Enter on Skip button when focused
  var skipLink = $("#skip");
  if (skipLink.length > 0) {
    skipLink.on("keyup", function(event) {
      if (event.key === "Enter") {
        $(this).trigger('click');
      }
    });
  }

  // FAQ toggle
  $('.faq-toggle').on('click', function(){
    var toggle = $(this);
    var ref = toggle.data('ref');
    toggle.toggleClass('collapsed');

    if (toggle.hasClass('collapsed')) {
      $('#'+ref+' button').each(function(){ var button = $(this); button.addClass('collapsed'); });
      $('div[data-bs-parent="#'+ref+'"]').each(function(){ var div = $(this); div.removeClass('show'); });
    } else {
      $('#'+ref+' button').each(function(){ var button = $(this); button.removeClass('collapsed'); });
      $('div[data-bs-parent="#'+ref+'"]').each(function(){ var div = $(this); div.addClass('show'); });
    }
  });

  // FAQ search
  $('.faq-search input').on('input', filterFaqs);

  function filterFaqs() {
    var searchTerm = $('.faq-search input').val().toLowerCase();

    $('.faq-item:not(.none)').each(function () {
      var faqTitle = $(this).find('.faq-title').text().toLowerCase();
      var faqText = $(this).find('.wysiwyg').text().toLowerCase();

      var matchesSearch = searchTerm === '' || faqTitle.includes(searchTerm) || faqText.includes(searchTerm);

      if (matchesSearch) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $('.faqs').each(function (){
      var error_message = true;
      var faqs = $(this);
      
      faqs.find('.faq-item:not(.none)').each(function (){
        var item = $(this);
        if (item.css('display') !== 'none') {
          error_message = false;
          return false;
        }
      });

      let faqsNone = faqs.find('.faq-item.none');

      if (error_message == true) {
        //faqs.find('.faq-item.none').removeClass('d-none');
        for (faqsNoneItem of faqsNone) {
          parent = faqsNoneItem.parentElement;
          container = document.getElementById(parent.getAttribute('id') + 'Container');
          container.classList.remove('hasSearch');
          container.style.display = 'none';
          parent.setAttribute('aria-live', '');
        }//for
      } else {
        //faqs.find('.faq-item.none').addClass('d-none');
        for (faqsNoneItem of faqsNone) {
          parent = faqsNoneItem.parentElement;
          container = document.getElementById(parent.getAttribute('id') + 'Container');
          container.classList.add('hasSearch');
          container.style.display = 'block';
          parent.setAttribute('aria-live', 'polite');
        }//for
      }//if
    });

    //Check to see if we are showing any FAQs and if we are not, show the error message
    let hasSearch = document.querySelector('.hasSearch');
    if (hasSearch) {
      document.getElementById('faqsErrorMessage').style.display = 'none';
      document.getElementById('faqsErrorMessageText').setAttribute('aria-live', '');
    } else {
      document.getElementById('faqsErrorMessage').style.display = 'block';
      document.getElementById('faqsErrorMessageText').setAttribute('aria-live', 'polite');
    }//if

  }

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");

    //If we are on the homepage, change the logo on scroll
    if (document.body.classList.contains('home')) {
      let src = document.getElementById('frontHeaderLogo').getAttribute('src');
      if (! src.includes('_white.svg')) {
        let newSrc = src.replace(/\.svg/g, '_white.svg');
        document.getElementById('frontHeaderLogo').setAttribute('src', newSrc);
      }//if
    }//if
  } else {
    $("header").removeClass("scroll");
    
    //If we are on the homepage, change the logo on scroll
    if (document.body.classList.contains('home')) {
      let src = document.getElementById('frontHeaderLogo').getAttribute('src');
      if (src.includes('_white.svg')) {
        let newSrc = src.replace(/\_white.svg/g, '.svg');
        document.getElementById('frontHeaderLogo').setAttribute('src', newSrc);
      }//if
    }//if
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1380,
    };

    let windowWidth = $(window).width();
    let containerWidth = 0;
    // let containerWidth = $(".container").width() + 32;

    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    if (containerWidth == 0) {
      console.error("containerWidth = 0 in Global.js on line: 213");
      return;
    } else {
      containerWidth += 32; // account for the padding on a bs container
    }

    // now calculate the padding for the offset on the content
    var padding = (windowWidth - containerWidth) / 2 + 16;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "16px");
        $(this).css("padding-right", "16px");
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;

  if (scroll == 0) {
    dropdown.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerHeight + "px");
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {

  // Detecting potential zoom levels based on window dimensions
  var zoomLevel;
  if (window.innerWidth < window.outerWidth) {
    zoomLevel = window.outerWidth / window.innerWidth;
  } else {
    zoomLevel = window.innerWidth / window.outerWidth;
  }//if

  // Check if the inferred zoom level is greater than 200%
  if (zoomLevel >= 2) {
    // Actions for 200%+ zoom
      //console.log('Zoom level is greater than 200%.');

      $(".carousel-items_4").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick",
          }
        ],
        slidesToShow: 1,
      });
      $(".carousel-items_3").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            settings: "unslick",
          }
        ],
        slidesToShow: 1,
      });
    
      $(".carousel-items_2").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            settings: "unslick",
          }
        ],
        slidesToShow: 1,
      });

  } else {
      // Actions for other zoom levels
      //console.log('Zoom level is not greater than 200%.');

      $(".carousel-items_4").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick",
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            }
          }
        ],
        slidesToShow: 4,
      });
      $(".carousel-items_3").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick",
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            }
          }
        ],
        slidesToShow: 3,
      });
    
      $(".carousel-items_2").slick({
        arrows: true,
        dots: false,
        infinite: false,
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg height="23" width="17" viewBox="0 0 17 23"><path d="M2.77117 1.07484L15.4275 9.88158C16.4383 10.5805 16.4598 12.0645 15.4705 12.8064L3.25505 21.9035C2.10448 22.8605 0.480768 21.5056 1.22273 20.2045L6.51322 11.4623L0.760347 2.79533C0.0291406 1.50497 1.60984 0.160836 2.77117 1.07484Z"/></svg></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick",
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 2,
            }
          }
        ],
        slidesToShow: 2,
      });

  }

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);

  //Get all .submenu.megamenu
  let submenuItems = document.querySelectorAll('.submenu.megamenu.open');
        
  submenuItems.forEach(function(submenuItem) {
    submenuItem.classList.remove('open');
  });
  
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    // styles: [
    //   {
    //     featureType: "water",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         color: "#d3d3d3",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "transit",
    //     stylers: [
    //       {
    //         color: "#808080",
    //       },
    //       {
    //         visibility: "off",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.highway",
    //     elementType: "geometry.stroke",
    //     stylers: [
    //       {
    //         visibility: "on",
    //       },
    //       {
    //         color: "#b3b3b3",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.highway",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         color: "#ffffff",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.local",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         visibility: "on",
    //       },
    //       {
    //         color: "#ffffff",
    //       },
    //       {
    //         weight: 1.8,
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.local",
    //     elementType: "geometry.stroke",
    //     stylers: [
    //       {
    //         color: "#d7d7d7",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "poi",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         visibility: "on",
    //       },
    //       {
    //         color: "#ebebeb",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "administrative",
    //     elementType: "geometry",
    //     stylers: [
    //       {
    //         color: "#a7a7a7",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.arterial",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         color: "#ffffff",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.arterial",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         color: "#ffffff",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "landscape",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         visibility: "on",
    //       },
    //       {
    //         color: "#efefef",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road",
    //     elementType: "labels.text.fill",
    //     stylers: [
    //       {
    //         color: "#696969",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "administrative",
    //     elementType: "labels.text.fill",
    //     stylers: [
    //       {
    //         visibility: "on",
    //       },
    //       {
    //         color: "#737373",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "poi",
    //     elementType: "labels.icon",
    //     stylers: [
    //       {
    //         visibility: "off",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "poi",
    //     elementType: "labels",
    //     stylers: [
    //       {
    //         visibility: "off",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road.arterial",
    //     elementType: "geometry.stroke",
    //     stylers: [
    //       {
    //         color: "#d6d6d6",
    //       },
    //     ],
    //   },
    //   {
    //     featureType: "road",
    //     elementType: "labels.icon",
    //     stylers: [
    //       {
    //         visibility: "off",
    //       },
    //     ],
    //   },
    //   {},
    //   {
    //     featureType: "poi",
    //     elementType: "geometry.fill",
    //     stylers: [
    //       {
    //         color: "#dadada",
    //       },
    //     ],
    //   },
    // ],
    zoom: 14,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
